import React from 'react';

import { ButtonProps } from './interfaces';
import Main from './Main';

const Button: React.FC<ButtonProps> = (props) => {
  return <Main {...props} />;
};

export default Button;
